@if (contractor(); as contactor) {
  <div class="contractor">
    <onyx-avatar
      variant="company"
      [size]="32"
      [company]="{ logo: undefined }"
    ></onyx-avatar>

    <p>{{ contactor.companyProfile.displayName }}</p>
  </div>
} @else {
  -
}
